import { create } from 'zustand';
import { WizardState } from 'pages/StoryBlok/ClothesFinder/data/types';

export const useClothesFinderWizardStore = create<WizardState>((set) => ({
  currentStep: 1,
  wizardData: {},

  setNextStep: (step, data) =>
    set((state) => ({
      wizardData: {
        ...state.wizardData,
        [step]: state.wizardData[step] || data,
      },
      currentStep: step,
    })),

  setCurrentStep: (step) => set(() => ({ currentStep: step })),

  updateStepData: (step, updates) =>
    set((state) => {
      const currentStepData = state.wizardData[step] || {};

      return {
        wizardData: {
          ...state.wizardData,
          [step]: {
            ...currentStepData,
            linkParams: updates.linkParams || {},
          },
        },
      };
    }),
}));
